import React from "react";
import { Link } from "react-router-dom";
import SiteShell from "./SiteShell";
import styles from "./SiteShell.module.css";
import { getBrowserLocale, getLocalizedPath, translate } from "./i18n";

function NotFound({ forcedLocale }) {
  const locale = forcedLocale || getBrowserLocale();
  const t = (key, values) => translate(locale, key, values);

  return (
    <SiteShell locale={locale}>
      <section className={styles.statusPanel}>
        <h1 className={styles.statusTitle}>{t("notFoundTitle")}</h1>
        <p className={styles.statusText}>{t("notFoundText")}</p>
        <div className={styles.buttonRow}>
          <Link className={styles.buttonPrimary} to={getLocalizedPath("/", locale)}>
            {t("backToGallery")}
          </Link>
        </div>
      </section>
    </SiteShell>
  );
}

export default NotFound;
